<template>
    <div class="single-game-sport" v-if="matchId && matchesIn[matchId]">
        <div v-if="eventDetailsLoadingError !== false" class="group-game empty" @click.stop="$emit('reloadoffer')">
            <div>{{$t('OFFERLOADINGERROR')}}</div>
            <button v-if="eventDetailsLoadingError.callback !== undefined"
            @click.stop="eventDetailsLoadingError.callback();">
                {{'RETRYEVENTFETCH'}}
            </button>
        </div>
        <div class="livem-single-event" v-else>
            <div class="scroll-single-event">
                <div class="single-event group-game" v-if="sportState == 'prematch'">
                    <div class="ggame-heading" v-if="false">
                        <div class="ggame-heading-right">
                            <div class="arrow-container">
                                <img src="../../../assets/img/favourites-light-unselected.svg" alt="down arrow">
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="single-event-container lb-sport" :class="selectedTab !== 'outrights' ? 'sportbackcolor-'+sportMapping[matchesIn[matchId].sportId] : 'sportbackcolor-outrights'">
                            <div class="single-event-buttons" v-if="hasStatisticsOrStream">
                                <div class="event-tab-icon" v-on:click="changeTabEvent('headtohead')" v-if="brStatistics('headtohead')">
                                    <img src="../../../assets/img/icon-white-h2h.svg" alt="down arrow">
                                </div>
                                <div class="event-tab-icon" v-on:click="changeTabEvent('matchpreview')" v-if="brStatistics('matchpreview')">
                                    <img src="../../../assets/img/icon-white-matchpreview.svg" alt="down arrow">
                                </div>
                                <div class="event-tab-icon" v-on:click="changeTabEvent('livematch')" v-if="brStatistics('livepreview')">
                                    <img src="../../../assets/img/icon-white-live-match.svg" alt="down arrow">
                                </div>
                                <div class="event-tab-icon" v-on:click="changeTabEvent('livestream')"
                                v-if="matchesIn[matchId] && matchesIn[matchId].stream && matchesIn[matchId].stream === 'live'">
                                    <img src="../../../assets/img/icon-white-stream.svg" alt="down arrow">
                                </div>
                            </div>
                            <div class="sport-icon lb-sport event-bg-sporticon" :class="getSportIconClass(matchesIn[matchId].sportId)"></div>
                            <div class="single-event-content">
                                <div class="single-event-top">
                                    <div class="stats-row">
                                        <div class="stats-row-left prematch-event-header">
                                            <i class="sportsicon icon-arrowleft event-back-icon" @click="selectMatch(null)"></i>
                                            <div class="ggame-live-stream" v-if="matchesIn[matchId].stream && matchesIn[matchId].stream !== 'nostream'" >
                                            <div class="icon-stream-booked">
                                                <i class="iconset icon-stream"></i>
                                            </div>
                                        </div>
                                            <p class="tournament-time">{{matchTournamentName}}</p>
                                        </div>
                                        <div class="match-outrights-icon" v-if="(globals && globals.publicConfig && globals.publicConfig.verticalsAvailable && globals.publicConfig.verticalsAvailable.outrights) && outrightsIn !== undefined && outrightsIn.matchIds.includes(matchId)">
                                            <img src="../../../assets/img/icon-outrights.svg">
                                        </div>
                                    </div>
                                    <div class="stats-line"></div>
                                </div>
                                <div class="single-event-bottom">
                                    <div class="stats-row bottom">
                                        <div class="prematch-teams">
                                            <p class="prematch-stats-team">{{matchesIn[matchId].teamNameOne || 'not defined'}} - {{matchesIn[matchId].teamNameTwo || 'not defined'}}</p>
                                        </div>
                                    </div>
                                    <div class="stats-row bottom">
                                        <div class="stats-row-left">
                                            <p class="tournament-time">{{$predefinedLocalDateFormat(matchesIn[matchId].matchDate)}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single-event-tabs" v-if="false && (globals && globals.publicConfig && globals.publicConfig.verticalsAvailable && globals.publicConfig.verticalsAvailable.outrights)
                            && (outrightsIn && outrightsIn.matchIds && outrightsIn.matchIds.includes(matchId))">
                            <div class="tab-item"  @click="showOddsTab = true" :class="showOddsTab ? 'active' : ''">{{$t('ODDS')}}</div>
                            <div @click="showOddsTab = false" :class="showOddsTab ? '' : 'active'" class="tab-item">
                                {{$t('OUTRIGHTS')}}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="single-event group-game">
                    <!--div class="ggame-heading">
                        <div class="ggame-heading-left">
                            <i class="sportsicon icon-arrowleft event-back-icon" @click="selectMatch(null)"></i>
                        </div>
                    </div-->

                    <div class="single-event-container lb-sport" :class="'sportbackcolor-'+sportMapping[matchesIn[matchId].sportId]">
                        <div class="single-event-buttons" v-if="hasStatisticsOrStream">
                            <div class="event-tab-icon" v-on:click="changeTabEvent('headtohead')" v-if="brStatistics('headtohead')">
                                <img src="../../../assets/img/icon-white-h2h.svg" alt="down arrow">
                            </div>
                            <div class="event-tab-icon" v-on:click="changeTabEvent('matchpreview')" v-if="brStatistics('matchpreview')">
                                <img src="../../../assets/img/icon-white-matchpreview.svg" alt="down arrow">
                            </div>
                            <div class="event-tab-icon" v-on:click="changeTabEvent('livematch')" v-if="brStatistics('livepreview')">
                                <img src="../../../assets/img/icon-white-live-match.svg" alt="down arrow">
                            </div>
                            <div class="event-tab-icon" v-on:click="changeTabEvent('livestream')"
                            v-if="matchesIn[matchId] && matchesIn[matchId].stream !== 'nostream' && matchesIn[matchId].state === 'live'">
                                <img src="../../../assets/img/icon-white-stream.svg" alt="down arrow">
                            </div>
                        </div>
                        <div class="sport-icon lb-sport event-bg-sporticon" :class="getSportIconClass(matchesIn[matchId].sportId)"></div>
                        <div class="single-event-content">
                            <div class="single-event-top">
                                <div class="stats-row">
                                    <div class="stats-row-left">
                                        <i class="sportsicon icon-arrowleft event-back-icon" @click="selectMatch(null)"></i>
                                        <div class="ggame-live-stream" v-if="matchesIn[matchId].stream && matchesIn[matchId].stream !== 'nostream'" >
                                            <div class="icon-stream-booked">
                                                <i class="iconset icon-stream"></i>
                                             <div class="pulse" v-if="matchesIn[matchId].stream === 'live'" ></div>
                                            </div>
                                        </div>
                                        <p class="tournament-time">
                                            {{
                                                currentScore
                                            }} <template
                                            v-if="
                                                (matchesIn[matchId].metaData.status !== 'NOT_STARTED'
                                                || (matchesIn[matchId].metaData.min !== undefined
                                                && matchesIn[matchId].metaData.periodStatus !== null))
                                            ">{{
                                                    $t('WEB_' + matchesIn[matchId].metaData.periodStatus)
                                            }}</template>
                                        </p>
                                    </div>
                                    <div class="stats-row-right">
                                        <div class="live-stats-item"
                                        v-for="period in displayedMatchPeriods"
                                        :key="period.index">
                                            <template v-if="period.name ==='teamGemScore'">
                                                <span class="sport-icon"></span>
                                            </template>
                                            <template v-if="period.name ==='teamTotalScore'">
                                                <span class="sport-icon lb-sport" :class="getSportIconClass(matchesIn[matchId].sportId)"></span>
                                            </template>
                                            <template v-if="period.name === 'teamRedCards'">
                                                <img src="../../../assets/img/red-card.svg" alt="red card">
                                            </template>
                                            <template v-if="period.name === 'teamYellowCards'">
                                                <img src="../../../assets/img/yellow-card.svg" alt="yellow card">
                                            </template>
                                            <template v-if="period.name === 'teamCorners'">
                                                <img src="../../../assets/img/corner.svg" alt="">
                                            </template>
                                            <template v-if="period.name === 'matchPeriod'">
                                                {{period.values.num}}
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="stats-line"></div>
                            </div>
                            <div class="single-event-bottom">
                                <div class="stats-row bottom">
                                    <div class="stats-row-left">
                                        <p class="live-stats-team">
                                            {{
                                                matchesIn[matchId].teamNameOne || 'not defined'
                                            }} <span
                                                class="sport-icon lb-sport"
                                                :class="getServeClass(matchesIn[matchId])"
                                                v-if="matchesIn[matchId].metaData.tServ !== undefined
                                                && matchesIn[matchId].metaData.tServ === 1"></span>
                                        </p>
                                    </div>
                                    <div class="stats-row-right stats-row-dynamic"
                                    ref="statsrowcontainer">
                                        <div class="score-arrow-left">
                                            <img src="../../../assets/img/arrow-left.svg"
                                            :class="{'shadowed': !canScrollPeriodStats.left}"
                                            @click.stop="navigateMatchPeriodStats('left')">
                                        </div>
                                        <div class="live-stats-item"
                                        v-for="period in displayedMatchPeriods"
                                        :key="period.index"
                                        >
                                            <template v-if="period.name ==='teamGemScore' ">
                                                {{period.values.t1GemScr}}
                                            </template>
                                            <template v-if="period.name ==='teamTotalScore'">
                                                {{period.values.t1Scr}}
                                            </template>
                                            <template v-if="period.name === 'teamRedCards'">
                                                {{period.values.t1RCrd}}
                                            </template>
                                            <template v-if="period.name === 'teamYellowCards'">
                                                {{period.values.t1YCrd}}
                                            </template>
                                            <template v-if="period.name === 'teamCorners'">
                                                {{period.values.t1Crn}}
                                            </template>
                                            <template v-if="period.name === 'matchPeriod'">
                                                {{period.values.t1Scr}}
                                            </template>
                                        </div>
                                        <!--
                                        <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t1Scr != undefined">{{matchesIn[matchId].metaData.t1Scr}}</div>
                                        <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t1RCrd != undefined">{{matchesIn[matchId].metaData.t1RCrd}}</div>
                                        <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t1YCrd != undefined">{{matchesIn[matchId].metaData.t1YCrd}}</div>
                                        <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t1Crn != undefined">{{matchesIn[matchId].metaData.t1Crn}}</div>
                                        <div class="live-stats-item" v-for="(period, p) in matchesIn[matchId].metaData.periods" :key="p">{{period.t1Scr}}</div>
                                        -->
                                    </div>
                                </div>
                                <div class="stats-row bottom">
                                    <div class="stats-row-left">
                                        <p class="live-stats-team">
                                            {{
                                                matchesIn[matchId].teamNameTwo || 'not defined'
                                            }} <span
                                                class="sport-icon lb-sport"
                                                :class="getServeClass(matchesIn[matchId])"
                                                v-if="matchesIn[matchId].metaData.tServ !== undefined
                                                && matchesIn[matchId].metaData.tServ === 2"></span>
                                        </p>
                                    </div>
                                    <div class="stats-row-right stats-row-dynamic">
                                        <div class="score-arrow-right">
                                            <img src="../../../assets/img/arrow-right.svg"
                                            :class="{'shadowed': !canScrollPeriodStats.right}"
                                            @click.stop="navigateMatchPeriodStats('right')">
                                        </div>
                                        <div class="live-stats-item"
                                        v-for="period in displayedMatchPeriods"
                                        :key="period.index">
                                            <template v-if="period.name ==='teamGemScore'">
                                                {{period.values.t2GemScr}}
                                            </template>
                                            <template v-if="period.name ==='teamTotalScore'">
                                                {{period.values.t2Scr}}
                                            </template>
                                            <template v-if="period.name === 'teamRedCards'">
                                                {{period.values.t2RCrd}}
                                            </template>
                                            <template v-if="period.name === 'teamYellowCards'">
                                                {{period.values.t2YCrd}}
                                            </template>
                                            <template v-if="period.name === 'teamCorners'">
                                                {{period.values.t2Crn}}
                                            </template>
                                            <template v-if="period.name === 'matchPeriod'">
                                                {{period.values.t2Scr}}
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="event-tabs" v-if="displayMultipleTabs">
                    <div
                        class="tab"
                        :class="{'active': selectedTab === 'odds'}"
                        @click="selectTab('odds')"
                    >
                        <p>{{$t('OUTCOMES_TAB')}}</p>
                    </div>
                    <div
                        v-if="displayOutrightsTab"
                        class="tab"
                        :class="{'active': selectedTab === 'outrights'}"
                        @click="selectTab('outrights')"
                    >
                        <p>{{$t('OUTRIGHTS_TAB')}}</p>
                    </div>
                    <template
                        v-if="hasMarketGroups"
                    >
                        <div
                            class="tab"
                            v-for="marketGroup in marketGroups"
                            :key="marketGroup.id"
                            :class="{'active': selectedTab === `marketgroup_${marketGroup.id}`}"
                            @click="selectTab(`marketgroup_${marketGroup.id}`)"
                        >
                            <p>{{marketGroup.name}}</p>
                        </div>
                    </template>
                </div>

                    <div v-show="tabevent == 'headtohead'" class="event-widgets">
                        <div class="sr-widget-1 widget-headtohead"></div>
                    </div>

                    <div v-show="tabevent == 'matchpreview'" class="event-widgets">
                        <div class="sr-widget-2 widget-matchpreview"></div>
                    </div>

                    <div v-show="tabevent == 'livematch'" class="event-widgets-full">
                        <div class="sr-widget-3"></div>
                    </div>
                    <div
                    v-if="tabevent == 'livestream'"
                    class="event-widgets stream-widget"
                    id="livestreamplayer">
                        <div class="loading-container" v-if="streamDataLoading">
                            <img src="../../../assets/img/loading.svg">
                        </div>
                        <template v-else-if="streamData != null">
                            <template v-if="!streamData.error && streamData.data != null && streamData.data.url !== ''">
                                <video>
                                    <source :src="streamData.data.url" type="video/hls" />
                                    <source :src="streamData.data.url" type="video/webm" />
                                </video>
                            </template>
                            <div v-else class="livestream-error-container">
                                <template v-if="streamData.error">
                                    <div class="no-stream-info">
                                        <img src="../../../assets/img/no-stream-bg.jpg">
                                        <div class="no-stream-info-text">
                                            {{$t(streamData.notice)}}
                                            <p v-if="streamData.showLoginButton">
                                                <a class="button button-blue"
                                                @click="promptLoginMenu()">
                                                    {{$t('TOGGLELOGIN')}}
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="">
                                        <img src="../../../assets/img/no-stream-bg.jpg">
                                        <p>{{$t('LIVESTREAM_NOT_AVAILABLE')}}</p>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                <div class="singleodds" :class="(tabevent == 'livematch') ? 'livematch-selected' : ''">
                    <vue-scroll class="single-game-sport" :class="(matchesIn[matchId].status == 'block' || globalEventBlock[sportState]) && showOddsTab ? 'is-blocked' : ''" v-if="hasActiveGroups">
                            <MarketGroupContainer
                                :marketGroups="groups"
                                :extendedMarketGroups="marketGroups"
                                :matchId="matchId"
                                :selectedGroup="selectedGroup"
                                v-if="selectedTab !== 'outrights'"
                            />
                            <OutrightOutcomes
                                v-else-if="showOutrightsTab"
                                :outright="connectedOutright[0]"
                            />
                        </vue-scroll>
                        <div class="single-noodds" v-else>
                            <img src="../../../assets/img/error-no-odds.svg">
                            <p>{{$t('NOODDSAVAILABLEATTHISMOMENT')}}</p>
                        </div> <!-- TODO Show this if there is no odds available -->
                    </div>

                <!--div class="liveh-match-single" v-if="hasStatisticsOrStream">
                    <div class="liveh-match-single-events">
                        <div class="liveh-event-switch-item" :class="{'is-selected': (tab == 'outcomes')}" v-on:click="tab = 'outcomes'">{{$t('OUTCOMES')}}</div>
                        <div v-if="brStatistics('headtohead')" class="liveh-event-switch-item" :class="{'is-selected': (tab == 'headtohead')}" v-on:click="tab = 'headtohead'">{{$t('HEADTOHEAD')}}</div>
                        <div v-if="brStatistics('matchpreview')" class="liveh-event-switch-item" :class="{'is-selected': (tab == 'matchpreview')}" v-on:click="tab = 'matchpreview'">{{$t('MATCHPREVIEW')}}</div>
                        <div v-if="brStatistics('livepreview') && sportState == 'live'" class="liveh-event-switch-item" :class="{'is-selected': (tab == 'livepreview')}" v-on:click="tab = 'livepreview'">{{$t('LIVEPREVIEW')}}</div>
                    </div>
                </div--> <!-- tabs below scoreboard -->

            </div>

            <!--div v-show="tab == 'headtohead'">
                <div class="sr-widget-1 widget-headtohead"></div>
            </div>

            <div v-show="tab == 'matchpreview'">
                <div class="sr-widget-2"></div>
            </div>

            <div v-show="tab == 'livepreview'">
                <div class="sr-widget-3"></div>
            </div-->
        </div>
    </div>
</template>

<script>
import
{
    mapActions,
    mapGetters,
}
from 'vuex';
import { Common } from '@om-retail/vue-common';
import WebHandlingApi from '../../api/WebHandling';
import OutrightOutcomes from './OutrightOutcomes.vue';
import MarketGroupContainer from '../../components/sport/single/MarketGroupContainer.vue';
import { isEmptyObject } from '../../helpers';

export default
{
    name: 'Match',
    props: ['outrightsIn'],
    async created()
    {
        const me = this;
        if (me.isMobile
        && (me.selectedMatch == null
        || me.selectedMatch.type !== 'sport'))
        {
            me.selectMatch({
                id: me.$route.params.matchId,
                type: 'sport',
            });
        }

        me.matchId = me.selectedMatch.id;

        me.generateGroups();

        me.$nextTick(() =>
        {
            me.checkMatchPeriodStats();
        });

        if (me.isMobile)
        {
            me.scoreItemMaxWidth = 25;
        }
        else
        {
            me.scoreItemMaxWidth = 40;
        }

        if (me.isMobile
        || (!me.isMobile && me.smallDesktop))
        {
            window.scroll({
                top: 0,
            });
        }
    },
    data()
    {
        return {
            groups: {},
            tabevent: '',
            matchId: null,
            scoreItemMaxWidth: 0,
            matchPeriodsDisplayStart: 0,
            totalDisplayedStats: 0,
            displayedMatchPeriods: [],
            matchPeriods: [],
            betRadarWidgetSet: false,
            streamData: null,
            streamDataLoading: false,
            showOddsTab: true,
            connectedOutright: null,
            selectedTab: 'odds',
            marketGroups: {},
        };
    },
    components:
    {
        MarketGroupContainer,
        OutrightOutcomes,
    },
    methods:
    {
        ...mapActions([
            'selectMatch',
            'setOutright',
            'removeOutright',
        ]),
        selectTab(tab)
        {
            this.selectedTab = tab;

            const me = this;

            if (me.connectedOutright != null
            && me.connectedOutright[0].connectedMatchOpen && me.connectedOutright[0].shouldRemove
            && tab !== 'outrights')
            {
                me.removeOutright(me.connectedOutright[0]);
            }
        },
        promptLoginMenu()
        {
            window.emit('promptLoginMenu');
        },
        getServeClass(match)
        {
            const me = this;

            let classOut = '';

            classOut = me.getSportIconClass(match.sportId);

            classOut += ` ${classOut.replace('sporticon-', '')}-serve`;

            return classOut;
        },
        getSportIconClass(sportId)
        {
            const me = this;

            let sportIconName = 'noicon';

            if (me.sportMapping[sportId] !== undefined)
            {
                sportIconName = me.sportMapping[sportId];
            }

            return `sporticon-${sportIconName}`;
        },
        generateGroups()
        {
            const me = this;

            if (me.matchesIn[me.matchId] === undefined)
            {
                return;
            }

            const groups = {};

            for (const outcome of me.matchesIn[me.matchId].outcomes)
            {
                if (outcome.status !== 'block' && outcome.status !== 'active')
                {
                    continue;
                }

                const [marketId] = outcome.markets;
                const { specHash } = outcome;

                if (groups[marketId] === undefined)
                {
                    groups[marketId] = {};
                }

                if (groups[marketId][specHash] === undefined)
                {
                    groups[marketId][specHash] = {
                        marketId,
                        specHash,
                        orderNum: me.sportTree.markets[marketId].orderNum,
                        name: me.sportTree.markets[marketId].name,
                        outcomes: {},
                        canShowMarketName: false,
                    };
                }

                outcome.name = Common.formatSpecName(
                    me.sportTree.outcomes[outcome.outcomeId].name,
                    me.matchesIn[me.matchId],
                    outcome.specifiers,
                );

                groups[marketId][specHash].outcomes[outcome.outcomeId] = outcome;
            }

            const marketGroups = {};
            let selectedGroupFound = false;

            if (this.selectedGroup === 'odds'
            || this.selectedGroup === 'outrights')
            {
                selectedGroupFound = true;
            }

            if (me.matchesIn[me.matchId].marketGroups)
            {
                for (const mGroup of me.matchesIn[me.matchId].marketGroups)
                {
                    let name = me.$t('UNDEFINEDMARKETGROUPNAME');
                    let orderNum = 9999999;
                    let hasOutcomes = false;

                    if (this.sportTree.marketGroups
                    && this.sportTree.marketGroups[mGroup.id])
                    {
                        name = this.sportTree.marketGroups[mGroup.id].name;
                        orderNum = this.sportTree.marketGroups[mGroup.id].orderNum;
                    }

                    const groupLines = {};

                    for (const marketGroupId of mGroup.markets)
                    {
                        const marketGroupIdInt = parseInt(marketGroupId, 10);

                        if (groups[marketGroupIdInt])
                        {
                            if (!groupLines[marketGroupIdInt])
                            {
                                groupLines[marketGroupIdInt] = {};
                            }

                            for (const specHash in groups[marketGroupIdInt])
                            {
                                if (groups[marketGroupIdInt][specHash]
                                && groups[marketGroupIdInt][specHash].outcomes
                                && !isEmptyObject(groups[marketGroupIdInt][specHash].outcomes))
                                {
                                    hasOutcomes = true;
                                    groupLines[marketGroupIdInt][specHash] = groups[marketGroupIdInt][specHash];
                                }
                            }
                        }
                    }

                    if (hasOutcomes)
                    {
                        marketGroups[mGroup.id] = {
                            groups: groupLines,
                            id: mGroup.id,
                            orderNum,
                            name,
                            canShowMarketName: false,
                        };

                        if (!selectedGroupFound
                        && mGroup.id === this.selectedGroup)
                        {
                            selectedGroupFound = true;
                        }
                    }
                }
            }

            if (!selectedGroupFound)
            {
                this.resetSelectedTab();
            }

            me.groups = groups;
            me.marketGroups = marketGroups;
        },
        checkStatsWidth()
        {
            const me = this;

            let total = 0;

            if (me.$refs.statsrowcontainer)
            {
                const containerWidth = me.$refs.statsrowcontainer.clientWidth - 25;

                total = Math.floor(containerWidth / me.scoreItemMaxWidth);
            }

            me.totalDisplayedStats = total;
        },
        navigateMatchPeriodStats(direction = 'left')
        {
            const me = this;

            if (!me.canScrollPeriodStats[direction])
            {
                return;
            }

            if (direction === 'left'
            && me.matchPeriodsDisplayStart > 0)
            {
                me.matchPeriodsDisplayStart -= 1;
            }
            else if (direction === 'right'
            && me.matchPeriodsDisplayStart + me.totalDisplayedStats <= me.matchPeriods.length)
            {
                me.matchPeriodsDisplayStart += 1;
            }

            me.getDisplayedMatchPeriods();
        },
        getDisplayedMatchPeriods()
        {
            const me = this;

            if (me.matchPeriods.length <= me.totalDisplayedStats)
            {
                me.displayedMatchPeriods = me.matchPeriods;
            }

            me.displayedMatchPeriods = me.matchPeriods.slice(
                me.matchPeriodsDisplayStart,
                me.matchPeriodsDisplayStart + me.totalDisplayedStats,
            );
        },
        checkMatchPeriodStats()
        {
            const me = this;
            const periods = [];

            if (me.matchId !== null
            && me.matchesIn[me.matchId] !== undefined
            && me.matchesIn[me.matchId].metaData !== undefined
            && me.matchesIn[me.matchId].metaData != null)
            {
                if (me.matchesIn[me.matchId].metaData.t1GemScr !== undefined
                && me.matchesIn[me.matchId].metaData.t1GemScr !== null
                && me.matchesIn[me.matchId].metaData.t1GemScr !== ''
                && me.matchesIn[me.matchId].metaData.t2GemScr !== undefined
                && me.matchesIn[me.matchId].metaData.t2GemScr !== null
                && me.matchesIn[me.matchId].metaData.t2GemScr !== '')
                {
                    let { t1GemScr, t2GemScr } = me.matchesIn[me.matchId].metaData;

                    if (me.globals.props.sportScoringMapping)
                    {
                        const matchOut = me.matchesIn[me.matchId];

                        if (me.globals.props.sportScoringMapping[matchOut.sportId])
                        {
                            if (me.globals.props
                                .sportScoringMapping[matchOut.sportId][t1GemScr.toString()] !== undefined)
                            {
                                t1GemScr = me.$t(
                                    me.globals.props.sportScoringMapping[matchOut.sportId][t1GemScr.toString()],
                                );
                            }

                            if (me.globals.props
                                .sportScoringMapping[matchOut.sportId][t2GemScr.toString()] !== undefined)
                            {
                                t2GemScr = me.$t(
                                    me.globals.props.sportScoringMapping[matchOut.sportId][t2GemScr.toString()],
                                );
                            }
                        }
                    }
                    periods.push({
                        name: 'teamGemScore',
                        values:
                        {
                            t1GemScr,
                            t2GemScr,
                        },
                        index: 't1GemScr_t2GemScr',
                    });
                }

                if (me.matchesIn[me.matchId].metaData.t1Scr !== undefined
                && me.matchesIn[me.matchId].metaData.t2Scr !== undefined)
                {
                    periods.push({
                        name: 'teamTotalScore',
                        values:
                        {
                            t1Scr: me.matchesIn[me.matchId].metaData.t1Scr,
                            t2Scr: me.matchesIn[me.matchId].metaData.t2Scr,
                        },
                        index: 't1Scr_t2Scr',
                    });
                }

                if (me.matchesIn[me.matchId].metaData.t1RCrd !== undefined
                && me.matchesIn[me.matchId].metaData.t2RCrd !== undefined)
                {
                    periods.push({
                        name: 'teamRedCards',
                        values:
                        {
                            t1RCrd: me.matchesIn[me.matchId].metaData.t1RCrd,
                            t2RCrd: me.matchesIn[me.matchId].metaData.t2RCrd,
                        },
                        index: 't1RCrd_t2RCrd',
                    });
                }

                if (me.matchesIn[me.matchId].metaData.t1YCrd !== undefined
                && me.matchesIn[me.matchId].metaData.t2YCrd !== undefined)
                {
                    periods.push({
                        name: 'teamYellowCards',
                        values:
                        {
                            t1YCrd: me.matchesIn[me.matchId].metaData.t1YCrd,
                            t2YCrd: me.matchesIn[me.matchId].metaData.t2YCrd,
                        },
                        index: 't1YCrd_t2YCrd',
                    });
                }

                if (me.matchesIn[me.matchId].metaData.t1Crn !== undefined
                && me.matchesIn[me.matchId].metaData.t2Crn !== undefined)
                {
                    periods.push({
                        name: 'teamCorners',
                        values:
                        {
                            t1Crn: me.matchesIn[me.matchId].metaData.t1Crn,
                            t2Crn: me.matchesIn[me.matchId].metaData.t2Crn,
                        },
                        index: 't1Crn_t2Crn',
                    });
                }

                if (me.matchesIn[me.matchId].metaData.periods !== undefined)
                {
                    for (const period of me.matchesIn[me.matchId].metaData.periods)
                    {
                        periods.push({
                            name: 'matchPeriod',
                            values:
                            {
                                t1Scr: period.t1Scr,
                                t2Scr: period.t2Scr,
                                num: period.num,
                            },
                            index: `t1Scr_t2Scr_period_${period.num}`,
                        });
                    }
                }

                me.matchPeriods = periods;

                me.getDisplayedMatchPeriods();

                if (me.totalDisplayedStats === 0)
                {
                    me.$nextTick(() =>
                    {
                        me.checkStatsWidth();
                    });
                }
            }
        },
        brStatistics(product)
        {
            const me = this;

            if (me.globals.publicConfig.statistics
            && me.globals.publicConfig.statistics.betRadar)
            {
                if (me.globals.publicConfig.statistics.betRadar.supportedSports != null
                && me.globals.publicConfig.statistics.betRadar
                    .supportedSports[me.matchesIn[me.matchId].sportId.toString()] != null
                && me.globals.publicConfig.statistics.betRadar
                    .supportedSports[me.matchesIn[me.matchId].sportId.toString()][product])
                {
                    return true;
                }
            }

            return false;
        },
        changeTabEvent(name)
        {
            const me = this;

            if (me.tabevent === name)
            {
                me.tabevent = '';
            }
            else
            {
                me.tabevent = name;

                if (name === 'livestream')
                {
                    me.getStreamData();
                }
            }
        },
        connectBetradarWidget()
        {
            const me = this;

            if (me.globals.publicConfig.statistics && me.globals.publicConfig.statistics.betRadar)
            {
                if (me.matchesIn[me.matchId] != null
                && me.matchesIn[me.matchId].sConn !== undefined
                && me.matchesIn[me.matchId].sConn.match
                && me.matchesIn[me.matchId].sConn.match['1'] !== undefined)
                {
                    me.$nextTick(() =>
                    {
                        try
                        {
                            if (me.brStatistics('headtohead') === true)
                            {
                                // eslint-disable-next-line
                                SIR('addWidget', '.sr-widget-1', 'headToHead.standalone', { matchId: parseInt(me.matchesIn[me.matchId].sConn.match['1'], 10) });
                            }

                            if (me.brStatistics('matchpreview') === true)
                            {
                                // eslint-disable-next-line
                                SIR('addWidget', '.sr-widget-2', 'match.preview', { matchId: parseInt(me.matchesIn[me.matchId].sConn.match['1'], 10) });
                            }

                            if (me.brStatistics('livepreview') === true)
                            {
                                // eslint-disable-next-line
                                SIR('addWidget', '.sr-widget-3', 'match.lmtPlus', { layout: 'topdown', matchId: parseInt(me.matchesIn[me.matchId].sConn.match['1'], 10) });
                            }
                        }
                        catch (error)
                        {
                            console.error('br stats match', error);
                        }
                    });
                }
            }
        },
        async getStreamData()
        {
            const me = this;

            if (me.matchesIn[me.matchId].state !== 'live' && me.matchesIn[me.matchId].stream !== 'live')
            {
                return;
            }

            if (me.streamData === null
            || me.streamData.error)
            {
                me.streamDataLoading = true;

                try
                {
                    const streamData = await WebHandlingApi.getStreamByMatchId(me.matchId);

                    if (streamData.error
                    && streamData.code === 'streaming_session_restricted')
                    {
                        streamData.showLoginButton = true;
                    }

                    me.streamData = streamData;
                }
                catch (e)
                {
                    console.log(e);
                    me.streamDataLoading = false;
                }
            }

            try
            {
                me.streamDataLoading = false;

                if (!me.streamData.error)
                {
                    me.$nextTick(() =>
                    {
                        // eslint-disable-next-line
                        const avvplInstance = new avvpl.setupPlayer({
                            id: 'livestreamplayer',
                        });
                    });
                }
            }
            catch (e)
            {
                console.log(e);
            }
        },
        resetStreamData()
        {
            const me = this;

            me.streamDataLoading = false;
            me.streamData = null;
        },
        resetSelectedTab()
        {
            const me = this;

            me.tabevent = '';
            me.selectedTab = 'odds';
        },
    },
    watch:
    {
        isMobile(val)
        {
            const me = this;

            if (val)
            {
                me.scoreItemMaxWidth = 25;
            }
            else
            {
                me.scoreItemMaxWidth = 40;
            }
        },
        'mainMatchObject.metaData'(val)
        {
            const me = this;

            if (val !== undefined
            && val !== null)
            {
                me.checkMatchPeriodStats();
            }
        },
        totalDisplayedStats()
        {
            const me = this;

            me.getDisplayedMatchPeriods();
        },
        matchesIn:
        {
            handler()
            {
                const me = this;
                me.generateGroups();
                me.connectBetradarWidget();
            },
            deep: true,
            immediate: true,
        },
        selectedMatch:
        {
            handler(val, oldVal)
            {
                const me = this;

                if (val == null
                || oldVal == null
                || oldVal.type !== val.type
                || (oldVal.type === val.type
                && oldVal.id !== val.id))
                {
                    me.groups = [];
                }

                me.matchId = val.id;

                if (me.matchesIn[me.matchId] === undefined)
                {
                    return;
                }

                me.$nextTick(() =>
                {
                    me.generateGroups();
                });

                me.connectBetradarWidget();
            },
            immediate: true,
        },
        matchId()
        {
            const me = this;

            me.resetStreamData();
            me.resetSelectedTab();
        },
        sportTree()
        {
            this.generateGroups();
        },
    },
    computed:
    {
        ...mapGetters(
            [
                'selectedMatch',
                'selectedMatches',
                'sportTree',
                'sportState',
                'isMobile',
                'matchesIn',
                'globalEventBlock',
                'globals',
                'eventDetailsLoadingError',
                'smallDesktop',
                'connectedOutrights',
            ],
        ),
        showOutrightsTab()
        {
            const me = this;

            if ((me.globals
            && me.globals.publicConfig
            && me.globals.publicConfig.verticalsAvailable
            && !me.globals.publicConfig.verticalsAvailable.outrights)
            || me.connectedOutrights == null)
            {
                me.showOddsTab = true;
                return false;
            }

            if (me.outrightsIn.matchIds.includes(me.matchId))
            {
                // eslint-disable-next-line guard-for-in
                for (const outright in me.connectedOutrights)
                {
                    if (me.connectedOutrights[outright].outrights[0].tree)
                    {
                        const tree = [...me.connectedOutrights[outright].outrights[0].tree];

                        for (const treeItem in tree)
                        {
                            if (tree[treeItem].connectionId === me.matchId && tree[treeItem].connectionType === 'match')
                            {
                                me.connectedOutright = [me.connectedOutrights[outright].outrights[0]];
                                me.connectedOutrightMarket = [me.connectedOutrights[outright].outrights[0].markets];

                                const outrightOut = me.connectedOutright[0];
                                if (outrightOut.connectedMatchOpen === undefined)
                                {
                                    outrightOut.connectedMatchOpen = true;
                                    me.setOutright(outrightOut);
                                }

                                return true;
                            }
                        }
                    }
                }
            }

            me.showOddsTab = true;
            return false;
        },
        selectedGroup()
        {
            if (this.selectedTab === 'odds'
            || this.selectedTab === 'outrights')
            {
                return this.selectedTab;
            }

            return parseInt(this.selectedTab.split('_')[1], 10);
        },
        hasActiveGroups()
        {
            return !isEmptyObject(this.groups);
        },
        hasMarketGroups()
        {
            return !isEmptyObject(this.marketGroups);
        },
        displayMultipleTabs()
        {
            return this.displayOutrightsTab || this.hasMarketGroups;
        },
        displayOutrightsTab()
        {
            return this.globals
                && this.globals.publicConfig
                && this.globals.publicConfig.verticalsAvailable
                && this.globals.publicConfig.verticalsAvailable.outrights
                && this.outrightsIn
                && this.outrightsIn.matchIds
                && this.outrightsIn.matchIds.includes(this.matchId);
        },
        hasStatisticsOrStream()
        {
            const me = this;

            if (me.brStatistics('headtohead') === true
            || me.brStatistics('matchpreview') === true
            || me.brStatistics('livepreview') === true
            || (me.matchesIn[me.matchId]
            && me.matchesIn[me.matchId].state === 'live'
            && me.matchesIn[me.matchId].stream === 'live'))
            {
                return true;
            }

            return false;
        },
        sportMapping()
        {
            const me = this;
            let val = {};

            if (me.globals
            && me.globals.props
            && me.globals.props.sportMapping)
            {
                val = me.globals.props.sportMapping;
            }

            return val;
        },
        mainMatchObject()
        {
            const me = this;

            return me.matchesIn[me.matchId] || null;
        },
        canScrollPeriodStats()
        {
            const me = this;
            let left = false;
            let right = false;

            if (me.totalDisplayedStats + me.matchPeriodsDisplayStart >= me.matchPeriods.length)
            {
                right = false;
            }
            else
            {
                right = true;
            }

            if (me.matchPeriodsDisplayStart > 0)
            {
                left = true;
            }

            return {
                left,
                right,
            };
        },
        currentScore()
        {
            const me = this;

            return Common.formatLiveEventDetails(me.matchesIn[me.matchId]);
        },
        matchTournamentName()
        {
            const me = this;

            return (me.sportTree.tournaments[me.matchesIn[me.matchId].tournamentId] !== undefined)
                ? me.sportTree.tournaments[me.matchesIn[me.matchId].tournamentId].tournamentName
                : me.$t('UNDEFINEDTOURNAMENTNAME');
        },
    },
};
</script>

<style>
@import "https://avplayer-cdn.akamaized.net/dist/latest/avvpl-player.css";
</style>
